import React, { useState, useEffect, useCallback } from "react"
import PropTypes from "prop-types"
import NewsStoryCards from "../NewsStoryCard/NewsStoryCard"
import Pagination from "../Pagination/Pagination"
import * as style from "./ListPaginationFilterWrapperUk-tw-styles"
import FilterListing from "../FilterListing/FilterListing"
import { CLEAR_ALL, UK, CAREERS } from "../../constants/filterValue.constants"

const ListPaginationFilterWrapperUk = props => {
  let url = ""
  let urlArray = []
  let queryParams = ""
  let newURLData = ""
  let newURL = []
  let replacedStr = ""
  const { newsCardsListCollection, isGeneralNews, variant } = props
  const styles = style[variant] || style.defaultStyle
  const [newsList, setNewsList] = useState(newsCardsListCollection.items)
  const PAGE_VALUE = 10
  const [currentPage, setCurrentPage] = useState(1)
  const [firstindex, setfirstindex] = useState(0)
  const [lastindex, setlastindex] = useState(10)
  const [selectedCategory, setSelectedCategory] = useState("")
  const [toggle, setToggle] = useState(false)
  const totalPages = Math.ceil(newsList.length / PAGE_VALUE)
  let ftag = ""
  if (isGeneralNews) {
    ftag = ""
  } else {
    ftag = UK
  }
  const onPageChange = pageNumber => {
    if (typeof window != "undefined") {
      const url = new URL(window.location);
      const params = new URLSearchParams(url.search);
      const ftag = params.get('ftag') || UK; // Default to UK if ftag is not present
      const fop = params.get('fop') || ''; // Default to empty string if fop is not present
  
      queryParams = `?filter=${selectedCategory}&ftag=${ftag}&fop=${fop}&page=${pageNumber}`;
      const newURL = url.origin + url.pathname + queryParams;
      history.pushState({}, "", newURL);
      location.reload();
    }
    changePageIndex(pageNumber, PAGE_VALUE);
  };
  
  const changePageIndex = (pageNo, pageValue) => {
    setCurrentPage(parseInt(pageNo))
    setfirstindex(pageNo * pageValue - pageValue)
    setlastindex(pageNo * pageValue)
  }
  useEffect(() => {
    // when user refresh or reload the page data will render according to slug value
    if (typeof window != "undefined") {
      url = new URL(window.location.href)
      if (url?.search) {
        const srchURL = url.search.endsWith("/")
          ? url.search.slice(0, -1)
          : url.search
        if (srchURL.indexOf("page") > -1) {
          urlArray = srchURL?.split("page=")
          if (urlArray[0]?.indexOf("filter") > -1) {
            // if the page url is like "?filter=Brands&ftag=&page=1"
            newURLData = urlArray[0]?.split("&ftag=")
            newURL = newURLData[0]?.split("filter=")
            if (newURL[1] === "") {
              setSelectedCategory("")
            } else {
              replacedStr = newURL[1].replaceAll("+", " ")
              setSelectedCategory(replacedStr.replace(/%20/g, " "))
            }

            changePageIndex(parseInt(urlArray[1]), PAGE_VALUE)
          } else {
            // if page url is "?page=1"
            setSelectedCategory("")
            changePageIndex(parseInt(urlArray[1]), PAGE_VALUE)
          }
        } else {
          urlArray = srchURL.split("filter=")
          replacedStr = urlArray[1].replaceAll("+", " ")
          setSelectedCategory(replacedStr.replace(/%20/g, " "))
          setCurrentPage(1)
        }
      }
    }
  }, [selectedCategory, currentPage])

  useEffect(() => {
    if (selectedCategory == "") {
      return
    }
    filterBrand()
  }, [selectedCategory])

  const filterByCat = (cat, ele) => {
    if (cat.includes(CAREERS)) {
      return ele.trim().includes(cat.trim())
    } else {
      return ele.trim() === cat.trim()
    }
  }
  const filterBrand = () => {
    const filteredBrands =
      newsCardsListCollection.items &&
      newsCardsListCollection.items?.filter(item => {
        return (
          item.categoryLinksCollection.items &&
          item.categoryLinksCollection.items?.some(ele => {
            return filterByCat(
              selectedCategory.toLowerCase(),
              ele?.label.toLowerCase()
            )
          })
        )
      })
    setNewsList(filteredBrands)
    return changePageIndex(currentPage, PAGE_VALUE)
  }
  const handleSelectChange = useCallback(
    (category, catid) => () => {
      if (category.toLowerCase() === CLEAR_ALL.toLowerCase()) {
        queryParams = "?page=1"
      } else {
        queryParams = `?filter=${category}&ftag=${ftag}&page=1`
      }

      if (typeof window != "undefined") {
        const url = new URL(window.location)
        const newURL = url?.origin + url?.pathname + queryParams
        history?.pushState({}, "", newURL)
        if (category.toLowerCase() === CLEAR_ALL.toLowerCase()) {
          //if brand is Clear All then reset the category to blank
          setSelectedCategory("")
          setNewsList(newsCardsListCollection.items)
          setCurrentPage(1)
        } else {
          //select functionality
          if (selectedCategory != category) {
            setSelectedCategory(category)
          }
        }
        setToggle(!toggle)
      }
      location.reload()
    },
    [selectedCategory, setSelectedCategory, currentPage, toggle]
  )

  return (
    <div>
      <FilterListing
        handleSelectChange={handleSelectChange}
        selectedCategory={selectedCategory}
        toggle={toggle}
        setToggle={setToggle}
        isGeneralNews={isGeneralNews}
      />
      <div className={styles?.newsMainWrapContainer}>
        {newsList.length > 0 &&
          newsList?.slice(firstindex, lastindex).map((item, index) => (
            <div className={styles?.newsMainWrap} key={index}>
              <NewsStoryCards {...item} />
            </div>
          ))}
      </div>
      {newsList.length > 0 && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
        />
      )}
    </div>
  )
}

ListPaginationFilterWrapperUk.propTypes = {
  newsCardsListCollection: PropTypes.object,
  isGeneralNews: PropTypes.bool,
  variant: PropTypes.string,
}

export default ListPaginationFilterWrapperUk
